export default "__VITE_ASSET__DxTprJat__"